<template>
  <v-container style="max-width: 1800px !important">
    <div class="pa-3 ma-3">
      <v-alert-dialog ref="alert"> </v-alert-dialog>

      <v-confirm-dialog
        ref="confirm"
        :acceptText="botonAceptar()"
        :cancelText="botonCancelar()"
        @accept="autorizarExcepcion"
        @cancel="cancelarExcepcion"
      >
      </v-confirm-dialog>

      <v-confirm-dialog
        ref="confirmCancelarAdenda"
        acceptText="Cancelar adenda"
        cancelText="Volver"
        @accept="confirmarCancelacionAdenda"
        @cancel="adendaParaCancelar = null"
      />

      <empleado-puestos
        ref="empleadoPuestos"
        :sueldos="false"
        @updated="getItems"
      />

      <carga-masiva
        ref="cargaMasiva"
        @change="getItems"
      >
      </carga-masiva>

      <v-dialog
        v-model="dialogAddEdit"
        max-width="80%"
        persistent
      >
        <v-card>
          <v-card-title>
            {{ editedItem.id_empleado == null ? 'Agregar' : 'Editar' }} Empleado
          </v-card-title>

          <v-card-text>
            <v-row class="pa-0 ma-0">
              <!-- DATOS PERSONALES -->
              <v-col
                cols="12"
                class="pa-0 ma-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-account
                  </v-icon>
                  Datos Personales
                </div>
              </v-col>
              <!-- NOMBRE / APELLIDOS -->
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.nombre"
                  label="Nombre"
                  outlined
                  dense
                  hide-details
                  autocomplete="off"
                  name="empleado_nombre_fake"
                  @focus="disableBrowserAutocomplete"
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.apellido_paterno"
                  label="Apellido paterno"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.apellido_materno"
                  label="Apellido materno"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <!-- FECHA NAC / GÉNERO / ESTADO CIVIL -->
              <v-col cols="4" class="py-0 my-0">
                <v-datetime-picker
                  v-model="editedItem.fecha_nacimiento"
                  label="Fecha de nacimiento"
                />
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  v-model="editedItem.genero"
                  :items="generos"
                  label="Género"
                  outlined
                  dense
                  hide-details
                >
                </v-autocomplete>
              </v-col>
              <!-- ESTADO CIVIL (ESTÁNDAR) -->
              <!--
              <v-col cols="4">
                <v-autocomplete
                  v-model="editedItem.id_estado_civil"
                  :items="estados_civiles"
                  item-value="id_estado_civil"
                  item-text="nombre"
                  label="Estado civil"
                  outlined
                  dense
                  hide-details
                >
                </v-autocomplete>
              </v-col>
              -->
              <!-- CURP / RFC / Número de Seguridad Social / NO. TRABAJADOR NOI -->
              <v-col cols="3">
                <v-text-field
                  v-model="editedItem.noi_numero_trabajador"
                  label="No. trabajador según NOI"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="6" class="mb-0 pb-0">
                <v-text-field
                  v-model="editedItem.curp_valor"
                  label="CURP"
                  outlined
                  dense
                  counter
                  maxlength="18"
                  :rules="curpRules"
                />
              </v-col>
              <v-col cols="6" class="mb-0 pb-0">
                <v-text-field
                  v-model="editedItem.rfc_valor"
                  label="RFC"
                  outlined
                  dense
                  counter
                  maxlength="13"
                  :rules="rfcRules"
                  @change="buscarUsuario"
                />
              </v-col>
              <!--
              <v-col cols="3" class="mb-0 pb-0">
                <v-text-field
                  v-model="editedItem.nss_valor"
                  label="Número de Seguridad Social"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              -->
              
              <!-- DATOS DE CONTACTO -->
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-phone
                  </v-icon>
                  Datos de Contacto
                </div>
              </v-col>
              <!-- TELÉFONO / EMAIL -->
              <v-col cols="6" class="d-flex align-center">
                <v-autocomplete-telefono
                  v-model="editedItem.telefono"
                  label="Teléfono de contacto"
                  url-get="/Catalogos/ListarPaises"
                />
              </v-col>
              <v-col cols="6" class="d-flex align-center">
                <v-text-field
                  v-model="editedItem.email"
                  label="Email de contacto"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <!-- INFORMACIÓN LABORAL -->
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-briefcase
                  </v-icon>
                  Información Laboral
                </div>
              </v-col>
              <!-- PUESTO / FECHA ALTA / SDI -->
              <template v-if="editedItem.id_empleado == null">
                <v-col cols="4">
                  <v-autocomplete
                    v-model="editedItem.id_puesto"
                    :items="puestos"
                    item-value="id_puesto"
                    item-text="nombre"
                    label="Puesto"
                    outlined
                    dense
                    hide-details
                  />
                </v-col>
                <v-col cols="4" class="my-0 py-0">
                  <v-datetime-picker
                    v-model="editedItem.fecha_alta"
                    label="Fecha de alta"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.sueldo_bruto_quincenal"
                    type="number"
                    step="0.01"
                    min="0"
                    label="Sueldo quincenal bruto"
                    outlined
                    dense
                    hide-details
                    :rules="[
                      v => v === 0 || !!v || 'Requerido',
                      v => /^\d+(?:\.\d{1,2})?$/.test(String(v)) || 'Solo números con 2 decimales'
                    ]"
                  />
                </v-col>
              </template>
              <template v-else>
                <v-row class="ma-0" dense>
                  <v-col cols="12" md="4">
                    <div class="text-caption grey--text text--darken-1">
                      Puesto
                    </div>
                    <div class="subtitle-2 font-weight-medium">
                      {{ editedItem.nombre_puesto || '—' }}
                    </div>
                  </v-col>

                  <v-col cols="12" md="4">
                    <div class="text-caption grey--text text--darken-1 my-0 py-0">
                      Fecha de alta
                    </div>
                    <div class="subtitle-2 font-weight-medium my-0 py-0">
                      {{ editedItem.fecha_alta }}
                    </div>
                  </v-col>

                  <v-col cols="12" md="4">
                    <div class="text-caption grey--text text--darken-1">
                      Sueldo quincenal bruto
                    </div>
                    <div class="subtitle-2 font-weight-bold">
                      {{ editedItem.sueldo_bruto_quincenal == null ? 'N/D' : formatMoney(editedItem.sueldo_bruto_quincenal) }}
                    </div>
                  </v-col>
                </v-row>
              </template>
              <!-- INFORMACIÓN LEGAL/FISCAL -->
              <!--
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-scale-balance
                  </v-icon>
                  Información Legal/Fiscal
                </div>
              </v-col>
              -->
              <!-- RÉGIMEN SUELDOS / ESTADO CIVIL LEGAL -->
              <!--
              <v-col cols="6">
                <v-select
                  v-model="editedItem.regimen_sueldos"
                  :items="siNoOptions"
                  label="¿Tiene activo el régimen de sueldos y salarios e ingresos asimilados a salarios?"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="editedItem.id_estado_civil_legal"
                  :items="estadosCivilesLegales"
                  item-value="id_estado_civil"
                  item-text="nombre"
                  label="Estado civil [Contrato y Aspectos Legales]"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              -->
              <!-- CRÉDITOS / OBLIGACIONES -->
              <!---
              <v-col cols="6">
                <v-select
                  v-model="editedItem.tiene_credito"
                  :items="siNoOptions"
                  label="¿Tiene algún crédito u obligación legal que afecte su nómina?"
                  outlined
                  dense
                  hide-details
                  @change="changeCredit"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="editedItem.ids_tipo_credito"
                  :items="creditoTipos"
                  item-value="id_rh_credito_tipo"
                  item-text="nombre"
                  label="Tipo de crédito u obligación legal"
                  outlined
                  dense
                  hide-details
                  multiple
                  chips
                  deletable-chips
                  :disabled="editedItem.tiene_credito !== true"
                />
              </v-col>
              -->
              <!-- ACCESO AL SISTEMA -->
              <template
                v-if="
                  editedItem.id_empleado == null &&
                  editedItem.rfc_valor != null &&
                  editedItem.rfc_valor.length == 13
                "
              >
                <v-col cols="12" class="pa-0 ma-0 text-center">
                  <br>
                  <div class="text-subtitle-1 font-weight-bold">
                    <v-icon>
                      mdi-lock-outline
                    </v-icon>
                    Acceso al Sistema
                  </div>
                  <br>
                </v-col>
                <v-col cols="12" v-if="loadingUser">
                  <div class="text-center">
                    <v-progress-circular :size="50" color="primary" indeterminate />
                    <br><br>
                    <div class="text-subtitle-1">
                      Buscando Usuario
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" v-else class="text-body-1 text-center">
                  <template v-if="editedItem.crear_usuario">
                    No se ha detectado ningún usuario en el sistema con el RFC proporcionado.
                    Se creará un usuario nuevo para este empleado.
                  </template>
                  <template v-else>
                    Se ha detectado un usuario a nombre de {{ editedItem.nombre_usuario }}
                    en el sistema con el RFC proporcionado. No es necesario crear un usuario
                    para este empleado.
                  </template>
                </v-col>
              </template>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="closeDialogAddEdit">
              Cancelar
            </v-btn>
            <v-btn
              color="red"
              text
              class="white--text"
              :loading="loadingSave"
              :disabled="loadingSave"
              @click="saveDialogAddEdit"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- DETALLES -->
      <v-dialog v-model="dialogView" max-width="80%" persistent>
        <v-card>
          <v-card-title>Detalles del Empleado</v-card-title>
          <v-tabs
            v-if="tienePuestoActual && tienePuestoFuturo"
            v-model="tabView"
            grow
            @change="cambiarPuestoVista"
          >
            <v-tab value="actual">Puesto actual</v-tab>
            <v-tab value="futuro">Puesto futuro</v-tab>
          </v-tabs>
          <v-card-text v-if="loadingDetails" class="text-center py-8">
            <v-progress-circular
              indeterminate
              size="128"
              width="4"
              class="mb-3"
              color="primary"
            ></v-progress-circular>
            <div class="text-subtitle-2">
              Cargando detalles del empleado ...
            </div>
          </v-card-text>
          <v-card-text v-else>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="pa-0 ma-0 text-center">
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>mdi-account</v-icon>
                  Datos Personales
                </div>
              </v-col>

              <!-- DATOS PERSONALES -->
              <v-col cols="3">
                <div class="text-subtitle-2">Nombre:</div>
                <div>{{ viewedItem.nombre }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Apellido paterno:</div>
                <div>{{ viewedItem.apellido_paterno }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Apellido materno:</div>
                <div>{{ viewedItem.apellido_materno }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Fecha de nacimiento:</div>
                <div>{{ viewedItem.fecha_nacimiento_beauty || viewedItem.fecha_nacimiento }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Género:</div>
                <div>{{ viewedItem.genero == 0 ? 'Femenino' : 'Masculino' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Estado civil:</div>
                <div>{{ viewedItem.nombre_estado_civil || 'N/D' }}</div>
              </v-col>

              <!-- IDENTIFICACIONES -->
              <v-col cols="3">
                <div class="text-subtitle-2">CURP:</div>
                <div>{{ viewedItem.curp_valor }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">RFC:</div>
                <div>{{ viewedItem.rfc_valor }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Número de Seguridad Social:</div>
                <div>{{ viewedItem.nss_valor || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">No. trabajador (NOI):</div>
                <div>{{ viewedItem.noi_numero_trabajador || 'N/D' }}</div>
              </v-col>
              <v-col cols="6">
              </v-col>

              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-phone
                  </v-icon>
                  Datos de Contacto
                </div>
              </v-col>

              <!-- CONTACTO -->
              <v-col cols="6">
                <div class="text-subtitle-2">Dirección:</div>
                <div>{{ viewedItem.direccion || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2"># Exterior:</div>
                <div>{{ viewedItem.num_exterior || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2"># Interior:</div>
                <div>{{ viewedItem.num_interior || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Colonia:</div>
                <div>{{ viewedItem.colonia || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Código postal:</div>
                <div>{{ viewedItem.cp || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Estado:</div>
                <div>{{ viewedItem.nombre_estado || 'N/D' }}</div>
              </v-col>
                          
              <v-col cols="3">
                <div class="text-subtitle-2">Município:</div>
                <div>{{ viewedItem.nombre_municipio || 'N/D' }}</div>
              </v-col>



              <v-col cols="6">
                <div class="text-subtitle-2">Teléfono de contacto:</div>
                <div>{{ viewedItem.telefono || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Email de contacto:</div>
                <div>{{ viewedItem.email || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Nombre completo del contacto de emergencia:</div>
                <div>{{ viewedItem.nombre_contacto_emergencia || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Número de celular del contacto de emergencia:</div>
                <div>{{ viewedItem.telefono_contacto_emergencia || 'N/D' }}</div>
              </v-col>

              <!-- INFORMACIÓN LABORAL -->
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-briefcase
                  </v-icon>
                  Información Laboral
                </div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Puesto:</div>
                <div>{{ viewedItem.nombre_puesto }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Fecha de alta:</div>
                <div>{{ viewedItem.fecha_alta }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Sueldo quincenal bruto:</div>
                <div>{{ viewedItem.sueldo_bruto_quincenal != null ? formatMoney(viewedItem.sueldo_bruto_quincenal) : 'N/D' }}</div>
              </v-col>

              <v-col
                v-if="cuentasBancariasVista.length"
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>mdi-bank-outline</v-icon>
                  Cuentas bancarias
                </div>
              </v-col>

              <template v-for="(cuenta, index) in cuentasBancariasVista">
                <v-col :key="`cuenta-tipo-${index}`" cols="3">
                  <div class="text-subtitle-2">Tipo de cuenta:</div>
                  <div>{{ cuenta.tipo_cuenta_nombre || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-banco-${index}`" cols="3">
                  <div class="text-subtitle-2">Banco:</div>
                  <div>{{ cuenta.banco || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-moneda-${index}`" cols="3">
                  <div class="text-subtitle-2">Moneda:</div>
                  <div>{{ cuenta.moneda || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-beneficiario-${index}`" cols="3">
                  <div class="text-subtitle-2">Beneficiario:</div>
                  <div>{{ cuenta.nombre_beneficiario || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-clabe-${index}`" cols="3">
                  <div class="text-subtitle-2">CLABE interbancaria:</div>
                  <div>{{ cuenta.clave_int || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-cuenta-${index}`" cols="3">
                  <div class="text-subtitle-2">Cuenta:</div>
                  <div>{{ cuenta.cuenta || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-cie-${index}`" cols="3">
                  <div class="text-subtitle-2">CIE:</div>
                  <div>{{ cuenta.cie || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-referencia-${index}`" cols="3">
                  <div class="text-subtitle-2">Referencia:</div>
                  <div>{{ cuenta.referencia || 'N/D' }}</div>
                </v-col>

                <v-col :key="`cuenta-validacion-${index}`" cols="12" class="pt-0">
                  <div class="text-subtitle-2">Validación de la cuenta:</div>
                  <div>
                    {{ cuenta.validada == null ? 'Pendiente de validación' : (cuenta.validada ? 'Cuenta válida' : 'Cuenta no válida') }}
                    <span v-if="cuenta.validada_por"> · {{ cuenta.validada_por }}</span>
                    <span v-if="cuenta.fecha_validacion"> · {{ cuenta.fecha_validacion }}</span>
                  </div>
                  <div v-if="cuenta.observacion" class="red--text text-caption mt-1">
                    Observación: {{ cuenta.observacion }}
                  </div>
                </v-col>
              </template>

              <!-- INFORMACIÓN LEGAL/FISCAL -->
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-scale-balance
                  </v-icon>
                  Información Legal/Fiscal
                </div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">¿Tiene activo el régimen de sueldos y salarios e ingresos asimilados a salarios?:</div>
                <div>{{ (viewedItem.regimen_sueldos != null) ? (viewedItem.regimen_sueldos ? 'Sí' : 'No') : 'N/D' }}</div>
              </v-col>

              <!--
              <v-col cols="3">
                <div class="text-subtitle-2">Estado civil [Contrato y Aspectos Legales]:</div>
                <div>{{ viewedItem.nombre_estado_civil_legal || 'N/D' }}</div>
              </v-col>
              -->

              <v-col cols="4">
                <div class="text-subtitle-2">¿Tiene algún crédito u obligación legal que afecte su nómina?:</div>
                <div>{{ (viewedItem.tiene_credito != null) ? (viewedItem.tiene_credito ? 'Sí' : 'No') : 'N/D' }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Tipo de crédito u obligación legal:</div>
                <div>{{ (viewedItem.nombres_tipo_credito != null && viewedItem.nombres_tipo_credito.length > 0) ? (viewedItem.nombres_tipo_credito || []).join(', ') : 'N/A' }}</div>
              </v-col>

              <v-col cols="12">
                <v-simple-table dense class="mb-2">
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 33.33%">Nombre completo del beneficiario</th>
                      <th class="text-left" style="width: 33.33%">Número de celular del beneficiario</th>
                      <th class="text-left" style="width: 33.33%">Parentesco del beneficiario</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in viewedItem.beneficiarios" :key="'beneficiario-' + i">
                      <td>
                        {{ row.nombre_completo }}
                      </td>
                      <td>
                        {{ row.telefono }}
                      </td>
                      <td>
                        {{ row.nombre_parentesco }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col
                v-if="viewedItem.requisitos != null && viewedItem.requisitos.length > 0"
                cols="12"
                class="pa-0 ma-0 text-center"
              >
                <br>
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-file-document-outline
                  </v-icon>
                  Documentación
                </div>
              </v-col>
              <template
                v-for="expediente_requisito in viewedItem.requisitos"
              >
                <v-col
                  :key="expediente_requisito.codigo"
                  cols="6"
                >
                  <div
                    v-if="expediente_requisito.observacion != null"
                    class="red--text text-caption"
                  >
                    Motivo de Rechazo: {{expediente_requisito.observacion}}
                  </div>
                  <template v-if="expediente_requisito.tipo_documento == 1">
                    <v-viewer
                      v-if="expediente_requisito.documento != null"
                      v-model="expediente_requisito.documento"
                      urlBase="/api/RecursosHumanos/DescargarDocumento"
                      :label="`${expediente_requisito.nombre}`"
                    ></v-viewer>

                    <div v-else>
                      <div class="text-subtitle-2">{{expediente_requisito.nombre}}:</div>
                       <div>Documento no Proporcionado</div>
                    </div>

                    <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
                  </template>

                  <template v-else>
                    <div class="text-subtitle-2">{{expediente_requisito.nombre}}:</div>
                    <div>{{ expediente_requisito.documento || 'N/D' }}</div>
                    <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
                  </template>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="closeDialogView">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogContratos" max-width="1000px" persistent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>Contratos del empleado</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-subtitle class="d-flex align-center pt-0 pb-4">
            <v-icon small class="mr-2">mdi-account-outline</v-icon>
            <span>
              <span v-if="empleadoContratos.codigo_empleado">
                [{{ empleadoContratos.codigo_empleado }}] -
              </span>
              {{ empleadoContratos.nombre }} {{ empleadoContratos.apellido_paterno }} {{ empleadoContratos.apellido_materno }}
            </span>
            <v-spacer></v-spacer>
            <v-chip v-if="!loadingContratos" small color="primary" outlined>
              {{ contratos.length }} {{ contratos.length === 1 ? 'contrato' : 'contratos' }}
            </v-chip>
          </v-card-subtitle>
          <v-card-text v-if="loadingContratos" class="text-center py-8">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="mt-3">Cargando contratos...</div>
          </v-card-text>
          <v-card-text v-else>
            <v-alert v-if="contratos.length === 0" type="info" text class="mt-2">
              El empleado no tiene contratos asociados.
            </v-alert>
            <v-data-table
              v-else
              :headers="headersContratos"
              :items="contratos"
              :loading="loadingContratos"
              class="mt-2"
              dense
              hide-default-footer
              >
              <template v-slot:[`item.perfil`]="{ item }">
                <v-tooltip v-if="!item.historico" bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      small
                      label
                      v-bind="attrs"
                      v-on="on"
                      :color="item.empleado_perfil_completo ? 'success' : 'error'"
                    >
                      <v-icon left small>
                        {{ item.empleado_perfil_completo ? 'mdi-check-circle' : 'mdi-close-circle' }}
                      </v-icon>
                      {{ item.empleado_perfil_completo ? 'Completo' : 'Pendiente' }}
                    </v-chip>
                  </template>
                  <ul v-if="!item.empleado_perfil_completo" class="pl-4">
                    <li v-for="(error, index) in item.errores_empleado_perfil" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                  <span v-else>Perfil completo</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.contrato_documento`]="{ item }">
                <v-tooltip v-if="item.contrato_documento" bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-viewer
                        v-model="item.contrato_documento"
                        urlBase="/api/RecursosHumanos/DescargarContratoFirmado"
                        label="Contrato"
                        class="viewer-contrato-compacto"
                      />
                    </span>
                  </template>
                  <span>
                    Cargado por: {{ item.nombre_usuario_cargo_contrato || item.nombre_usuario_contrato || 'N/D' }}
                    <br>
                    Fecha de carga: {{ item.fecha_cargo_contrato || item.fecha_contrato || 'N/D' }}
                  </span>
                </v-tooltip>
                <span v-else class="text-caption text--secondary">Sin documento</span>
              </template>
              <template v-slot:[`item.adendas`]="{ item }">
                <div v-if="(item.adendas || []).length" class="d-flex flex-column align-center">
                  <v-chip small outlined color="primary" class="mb-1">
                    {{ (item.adendas || []).length }} {{ (item.adendas || []).length === 1 ? 'adenda' : 'adendas' }}
                  </v-chip>
                  <v-chip v-if="adendasPendientes(item).length" x-small color="warning" text-color="white" class="mb-1">
                    {{ adendasPendientes(item).length }} pendiente{{ adendasPendientes(item).length === 1 ? '' : 's' }}
                  </v-chip>
                  <v-chip v-if="adendasCargadas(item).length" x-small color="success" text-color="white">
                    {{ adendasCargadas(item).length }} cargada{{ adendasCargadas(item).length === 1 ? '' : 's' }}
                  </v-chip>
                </div>
                <span v-else class="text-caption text--secondary">Sin adendas</span>
              </template>
              <template v-slot:[`item.desde_puesto`]="{ item }">
                {{ item.desde_puesto }}
              </template>
              <template v-slot:[`item.hasta_puesto`]="{ item }">
                {{ item.hasta_puesto }}
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <v-tooltip v-if="!item.historico && !item.nombre_contrato" bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="abrirAsignarTipoContrato(item)">
                      <v-icon small>mdi-file-cog-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Asignar tipo de contrato</span>
                </v-tooltip>
                <v-tooltip v-if="!item.historico && item.empleado_perfil_completo && item.nombre_contrato && !item.contrato_documento" bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="abrirCargaContrato(item)">
                      <v-icon small>mdi-upload</v-icon>
                    </v-btn>
                  </template>
                  <span>Cargar contrato firmado</span>
                </v-tooltip>
                <v-tooltip v-if="!item.historico && item.empleado_perfil_completo && item.nombre_contrato && !item.contrato_documento" bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="abrirDescargaContrato(item)">
                      <v-icon small>mdi-file-download-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar contrato para firma</span>
                </v-tooltip>
                <v-tooltip v-if="!item.historico && item.contrato_documento" bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="abrirAdendasContrato(item)">
                      <v-icon small>mdi-file-document-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver adendas del contrato</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="closeDialogContratos">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <asignar-tipo-contrato-dialog
        v-model="dialogAsignarTipoContrato"
        :item="contratoParaAsignarTipo"
        @assigned="tipoContratoAsignado"
      />

      <cargar-contrato-dialog
        v-model="dialogCargarContrato"
        :item="contratoParaCarga"
        @uploaded="contratoCargado"
      />

      <v-dialog v-model="dialogDescargarContrato" max-width="480px" persistent>
        <v-card>
          <v-card-title>Descargar contrato para firma</v-card-title>
          <v-card-text>
            <div class="text-body-2 mb-4">Selecciona el lugar de firma para generar el contrato.</div>
            <v-select
              v-model="ciudadDescargaContrato"
              :items="lugaresFirma"
              label="Lugar de firma"
              outlined
              dense
              hide-details="auto"
            />
            <br>
            <v-btn text color="primary" block outlined :loading="descargandoContrato" :disabled="!ciudadDescargaContrato" @click="descargarContratoIndividual">
              Descargar Contrato
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="green" :disabled="descargandoContrato" @click="cerrarDescargaContrato">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDescargarAdenda" max-width="480px" persistent>
        <v-card>
          <v-card-title>Descargar adenda para firma</v-card-title>
          <v-card-text>
            <div class="text-body-2 mb-4">Selecciona el lugar de firma para generar la adenda.</div>
            <v-select
              v-model="ciudadDescargaAdenda"
              :items="lugaresFirma"
              label="Lugar de firma"
              outlined
              dense
              hide-details="auto"
            />
            <br>
            <v-btn text color="primary" block outlined :loading="descargandoAdenda" :disabled="!ciudadDescargaAdenda" @click="descargarAdendaIndividual">
              Descargar adenda
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="green" :disabled="descargandoAdenda" @click="cerrarDescargaAdenda">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAdendasContrato" max-width="720px" persistent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>Adendas del contrato</span>
            <v-spacer />
            <v-chip small outlined color="primary">
              {{ (contratoAdendas.adendas || []).length }} {{ (contratoAdendas.adendas || []).length === 1 ? 'adenda' : 'adendas' }}
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-row class="mb-2">
              <v-col cols="12" sm="6">
                <div class="text-caption grey--text text--darken-1">Empleado</div>
                <div class="font-weight-medium">
                  {{ empleadoContratos.nombre }} {{ empleadoContratos.apellido_paterno }} {{ empleadoContratos.apellido_materno }}
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-caption grey--text text--darken-1">Contrato</div>
                <div class="font-weight-medium">{{ contratoAdendas.nombre_contrato || 'Sin tipo de contrato' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-caption grey--text text--darken-1">Puesto</div>
                <div>{{ contratoAdendas.nombre_puesto || 'N/D' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-caption grey--text text--darken-1">Vigencia</div>
                <div>{{ contratoAdendas.desde_puesto || 'N/D' }} - {{ contratoAdendas.hasta_puesto || 'Indefinido' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-caption grey--text text--darken-1">Contrato cargado por</div>
                <div>{{ contratoAdendas.nombre_usuario_cargo_contrato || contratoAdendas.nombre_usuario_contrato || 'N/D' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-caption grey--text text--darken-1">Fecha de carga</div>
                <div>{{ contratoAdendas.fecha_cargo_contrato || contratoAdendas.fecha_contrato || '—' }}</div>
              </v-col>
              <v-col v-if="contratoAdendas.contrato_documento" cols="12">
                <v-viewer
                  v-model="contratoAdendas.contrato_documento"
                  urlBase="/api/RecursosHumanos/DescargarContratoFirmado"
                  label="Contrato firmado"
                />
              </v-col>
            </v-row>
            <v-divider class="mb-3" />
            <v-btn v-if="contratoAdendas.contrato_documento" small color="primary" @click="abrirCrearAdenda(contratoAdendas)">
              <v-icon left small>mdi-plus</v-icon>Agregar adenda
            </v-btn>
            <br>
            <br>
            <v-alert v-if="!(contratoAdendas.adendas || []).length" type="info" text dense>
              Este contrato no tiene adendas registradas.
            </v-alert>
            <v-data-table
              v-else
              :headers="headersAdendasContrato"
              :items="contratoAdendas.adendas"
              item-key="id_empleado_puesto_adenda"
              dense
              hide-default-footer
            >
              <template v-slot:[`item.estado`]="{ item }">
                <v-chip x-small :color="item.documento ? 'success' : 'warning'" text-color="white">
                  {{ item.documento ? 'Cargada' : 'Pendiente' }}
                </v-chip>
              </template>
              <template v-slot:[`item.fecha_cargo_adenda`]="{ item }">
                {{ item.fecha_cargo_adenda || item.fecha_cargo || '—' }}
              </template>
              <template v-slot:[`item.cargada_por`]="{ item }">
                {{ item.nombre_usuario_cargo_adenda || item.nombre_usuario_cargo || '—' }}
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <v-viewer
                  v-if="item.documento"
                  v-model="item.documento"
                  urlBase="/api/RecursosHumanos/DescargarEmpleadoPuestoAdenda"
                  label="Adenda"
                  class="viewer-adenda-compacto"
                />
                <template v-else>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" @click="abrirDescargaAdenda(item)"><v-icon small>mdi-file-download-outline</v-icon></v-btn>
                    </template>
                    <span>Descargar adenda</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" @click="abrirCargaAdenda(contratoAdendas, item)"><v-icon small>mdi-upload</v-icon></v-btn>
                    </template>
                    <span>Cargar adenda firmada</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" @click="cancelarAdenda(item)"><v-icon small>mdi-cancel</v-icon></v-btn>
                    </template>
                    <span>Cancelar adenda</span>
                  </v-tooltip>
                </template>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green" text @click="cerrarAdendasContrato">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogCrearAdenda" max-width="600px" persistent>
        <v-card>
          <v-card-title>Crear adenda</v-card-title>
          <v-card-text>
            <div class="text-subtitle-2">{{ contratoParaAdenda.nombre_puesto || '' }}</div>
            <div class="text-caption mb-4">{{ contratoParaAdenda.desde_puesto || '' }} - {{ contratoParaAdenda.hasta_puesto || '' }}</div>
            <v-select
              v-model="idTipoAdenda"
              :items="tiposAdenda"
              item-value="id_empleado_adenda_tipo"
              item-text="nombre"
              label="Tipo de adenda"
              outlined
              dense
              :loading="loadingTiposAdenda"
              :disabled="loadingTiposAdenda"
            />
            <v-select
              v-model="idMotivoAdenda"
              :items="motivosAdenda"
              item-value="id_empleado_adenda_motivo"
              item-text="nombre"
              label="Motivo de adenda"
              outlined
              dense
              :loading="loadingTiposAdenda"
              :disabled="loadingTiposAdenda"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green" text @click="cerrarCrearAdenda">Cancelar</v-btn>
            <v-btn color="red" text :disabled="!idTipoAdenda || !idMotivoAdenda" :loading="savingAdenda" @click="crearAdenda">
              Crear
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogCargaAdenda" max-width="600px" persistent>
        <v-card>
          <v-card-title>Cargar adenda firmada</v-card-title>
          <v-card-text>
            <div class="text-subtitle-2">{{ adendaParaCarga.nombre_adenda || '' }}</div>
            <div class="text-caption mb-4">{{ contratoAdendas.nombre_puesto || '' }}</div>
            <v-file-input
              v-model="archivoAdenda"
              accept="application/pdf,.pdf"
              label="Documento PDF"
              outlined
              dense
              show-size
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green" text @click="cerrarCargaAdenda">Cancelar</v-btn>
            <v-btn color="red" text :loading="savingCargaAdenda" :disabled="archivoAdenda == null" @click="cargarAdenda">
              Cargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogRecargaExpediente" max-width="650px" persistent>
        <v-card>
          <v-card-title>Solicitar nueva carga de documentación</v-card-title>
          <v-card-text>
            <div v-if="empleadoRecarga" class="mb-4">
              <div class="font-weight-medium">
                {{ empleadoRecarga.nombre }} {{ empleadoRecarga.apellido_paterno }} {{ empleadoRecarga.apellido_materno }}
              </div>
              <div class="text-caption grey--text">{{ empleadoRecarga.codigo_empleado }}</div>
            </div>

            <div class="text-body-2 grey--text mb-4">
              Selecciona el puesto cuya documentación debe capturarse nuevamente. Se conservará el expediente actual como histórico.
            </div>

            <v-progress-linear v-if="loadingPuestosExpediente" indeterminate color="primary" />

            <v-alert v-else-if="puestosExpediente.length === 0" type="warning" text dense>
              El empleado no tiene puestos actuales o futuros disponibles.
            </v-alert>

            <v-list v-else two-line class="py-0">
              <v-list-item
                v-for="puesto in puestosExpediente"
                :key="puesto.id_empleado_puesto"
                :disabled="Number(puesto.estado) !== 3"
              >
                <v-list-item-icon class="mr-3">
                  <v-checkbox
                    :input-value="puestoRecargaSeleccionado === puesto.id_empleado_puesto"
                    :disabled="Number(puesto.estado) !== 3"
                    hide-details
                    class="mt-0"
                    @change="seleccionarPuestoRecarga(puesto.id_empleado_puesto, $event)"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ puesto.nombre_puesto }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ puesto.periodo || construirPeriodoExpediente(puesto) }} · {{ puesto.estado_periodo || 'N/D' }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small :color="estadoExpedienteColor(puesto.estado)" text-color="white">
                    {{ puesto.estado_nombre || estadoExpedienteNombre(puesto.estado) }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="green" :disabled="savingRecargaExpediente" @click="closeDialogRecargaExpediente">Cancelar</v-btn>
            <v-btn
              text
              color="red"
              :loading="savingRecargaExpediente"
              :disabled="loadingPuestosExpediente || !puestoRecargaSeleccionado"
              @click="solicitarRecargaExpediente"
            >
              Solicitar nueva carga
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row>
        <!--
        <v-col cols="12" md="6">
          <v-card outlined class="pa-4">
            <div class="caption mb-1">Cumplimiento de Captura de RRHH</div>

            <div class="kpi-line">
              <span class="kpi-figure">{{ pct(stats.cumpliento_per) }}</span>
              <span class="kpi-pill kpi-pill--success">
                {{ nf(stats.cumpliento_num) }} /
                {{ nf(stats.total) }}
              </span>
            </div>

            <v-progress-linear :value="stats.cumpliento_per * 100" height="8" color="primary" class="mt-2"/>
            <div class="caption mb-1">&nbsp;</div>
          </v-card>
        </v-col>
        -->

        <v-col cols="12">
          <v-card outlined class="pa-4">
            <div class="caption mb-1 pl-3">Estado de los Expedientes</div>
            <v-row class="pa-0 ma-0">
              <v-col cols="4" class="my-0 py-0">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.pendiente_per) }}</span>
                  <span class="kpi-pill kpi-pill--success">
                    {{ nf(stats.pendiente_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear :value="stats.pendiente_per * 100" height="8" color="blue" class="mt-2"/>
                <div class="caption mb-1">Pendiente Carga de Documentación</div>
              </v-col>

              <v-col cols="4" class="my-0 py-0">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.validacion_per) }}</span>
                  <span class="kpi-pill kpi-pill--success">
                    {{ nf(stats.validacion_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear :value="stats.validacion_per * 100" height="8" color="warning" class="mt-2"/>
                <div class="caption mb-1">Proceso de Validación</div>
              </v-col>

              <v-col cols="4" class="my-0 py-0">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.validado_per) }}</span>
                  <span class="kpi-pill kpi-pill--success">
                    {{ nf(stats.validado_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear :value="stats.validado_per * 100" height="8" color="success" class="mt-2"/>
                <div class="caption mb-1">Documentacion Validada</div>
              </v-col>
            </v-row>
            
          </v-card>
        </v-col>

      
        <v-col cols="6">
          <v-btn color="primary" @click="openDialogAddEdit(null)">Agregar Empleado</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.codigoEmpleado"
            label="Código de empleado"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.nombre"
            label="Nombre"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>
        
        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.apellidoPaterno"
            label="Apellido Paterno"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.apellidoMaterno"
            label="Apellido Materno"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model.lazy="search.rfc"
            label="RFC"
            clearable
            dense
            hide-details
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="search.tipoPuestos"
            :items="areaPuestos"
            item-value="id_rh_area"
            item-text="nombre"
            label="Tipos de Puestos"
            outlined
            dense
            hide-details
            multiple
            chips
            deletable-chips
            clearable
            @change="changeTipoPuestos"
          />
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="search.puestos"
            label="Puestos"
            clearable
            :items="puestosFiltrados"
            item-value="id_puesto"
            item-text="nombre"
            dense
            hide-details
            outlined
            multiple
            chips
            deletable-chips
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="3">
          <v-btn
            block
            color="primary"
            text
            outlined
            @click="getItems"
            :disabled="loading"
            :loading="loading"
          >
            <v-icon>
              mdi-magnify
            </v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="items"
          >
            <template v-slot:[`item.nombre_puesto`]="{ item }">
              {{item.nombre_puesto}}
              <div
                v-if="item.nombre_puesto_futuro != null"
                class="text-caption font-italic"
              >
                Puesto futuro: {{item.nombre_puesto_futuro}}
              </div>
            </template>


            <template v-slot:[`item.id_estado_empleado`]="{ item }">
              <div class="expediente-estados">
                <v-tooltip bottom color="black" content-class="expediente-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      small
                      label
                      :color="estadoExpedienteColor(item.id_estado_empleado)"
                      :text-color="estadoExpedienteTextColor(item.id_estado_empleado)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left small>{{ estadoExpedienteIcon(item.id_estado_empleado) }}</v-icon>
                      {{ estadoExpedienteNombre(item.id_estado_empleado) }}
                    </v-chip>
                  </template>
                  <span>{{ estadoExpedienteTooltip(item, 'actual') }}</span>
                </v-tooltip>
                <div v-if="resumenExpediente(item, 'actual')" class="expediente-motivo caption">
                  {{ resumenExpediente(item, 'actual') }}
                </div>

                <v-tooltip
                  v-if="item.id_empleado_puesto_futuro != null"
                  bottom
                  color="black"
                  content-class="expediente-tooltip"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      small
                      label
                      outlined
                      :color="estadoExpedienteColor(item.id_estado_expediente_puesto_futuro)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left small>{{ estadoExpedienteIcon(item.id_estado_expediente_puesto_futuro) }}</v-icon>
                      {{ item.estado_expediente_puesto_futuro_nombre || estadoExpedienteNombre(item.id_estado_expediente_puesto_futuro) }}
                    </v-chip>
                  </template>
                  <span>{{ estadoExpedienteTooltip(item, 'próximo') }}</span>
                </v-tooltip>
                <div v-if="resumenExpediente(item, 'próximo')" class="expediente-motivo caption">
                  Próximo: {{ resumenExpediente(item, 'próximo') }}
                </div>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom color="black" content-class="acciones-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogAddEdit(item)">mdi-pencil</v-icon>
                </template>
                <span>Editar empleado</span>
              </v-tooltip>
              <v-tooltip bottom color="black" content-class="acciones-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogView(item)">mdi-eye</v-icon>
                </template>
                <span>Ver información del empleado</span>
              </v-tooltip>
              <v-tooltip bottom color="black" content-class="acciones-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogRecargaExpediente(item)">
                    mdi-file-refresh-outline
                  </v-icon>
                </template>
                <span>Solicitar nueva carga de documentación</span>
              </v-tooltip>
              <v-tooltip bottom color="black" content-class="acciones-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogPuestos(item)">mdi-history</v-icon>
                </template>
                <span>Historial de puestos</span>
              </v-tooltip>
              <v-tooltip bottom color="black" content-class="acciones-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-2" small v-bind="attrs" v-on="on" @click="openDialogContratos(item)">
                    mdi-file-document-multiple-outline
                  </v-icon>
                </template>
                <span>Ver contratos del empleado</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>

        <v-col cols="12" style="text-align: right;">
          <v-btn
            text
            color="primary"
            @click="openDialogCargaMasiva"  
          >
            <v-icon class="mr-2" small>mdi-upload</v-icon>
            Carga Masiva de Empleados
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from "vuex";
import VAlertDialog from "@/components/VAlertDialog.vue";
import VDatetimePicker from '@/components/VDatetimePicker.vue'
import VViewer from '@/components/VViewer.vue';
import VAutocompleteTelefono from '@/components/VAutocompleteTelefono.vue'
import EmpleadoPuestos from './Empleados/EmpleadoPuestos.vue';
import CargaMasiva from './Empleados/CargaMasiva.vue';
import VConfirmDialog from '@/components/VConfirmDialog.vue';
import AsignarTipoContratoDialog from './Contratos/AsignarTipoContratoDialog.vue';
import CargarContratoDialog from './Contratos/CargarContratoDialog.vue';

import { v4 } from 'uuid';

export default {
  components: {
    VAlertDialog,
    VDatetimePicker,
    VViewer,
    VAutocompleteTelefono,
    EmpleadoPuestos,
    CargaMasiva,
    VConfirmDialog,
    AsignarTipoContratoDialog,
    CargarContratoDialog
  },
  data: () => ({
    dialogView: false,
    dialogContratos: false,
    dialogAsignarTipoContrato: false,
    contratoParaAsignarTipo: null,
    dialogCargarContrato: false,
    contratoParaCarga: null,
    dialogDescargarContrato: false,
    contratoParaDescarga: null,
    ciudadDescargaContrato: null,
    descargandoContrato: false,
    dialogDescargarAdenda: false,
    adendaParaDescarga: null,
    ciudadDescargaAdenda: null,
    descargandoAdenda: false,
    lugaresFirma: ['Villahermosa, Tab.', 'Puebla, Pue.'],
    dialogAdendasContrato: false,
    contratoAdendas: {},
    dialogCrearAdenda: false,
    loadingTiposAdenda: false,
    savingAdenda: false,
    tiposAdenda: [],
    idTipoAdenda: null,
    motivosAdenda: [],
    idMotivoAdenda: null,
    contratoParaAdenda: {},
    dialogCargaAdenda: false,
    adendaParaCarga: {},
    adendaParaCancelar: null,
    archivoAdenda: null,
    savingCargaAdenda: false,
    dialogRecargaExpediente: false,
    loadingPuestosExpediente: false,
    savingRecargaExpediente: false,
    empleadoRecarga: null,
    puestosExpediente: [],
    puestoRecargaSeleccionado: null,
    tabView: null,
    puestosVista: {
      actual: null,
      futuro: null
    },
    dialogAddEdit: false,
    loading: false,
    loadingContratos: false,
    items: [],
    contratos: [],
    empleadoContratos: {
      id_empleado: null,
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      codigo_empleado: ''
    },
    headers: [
      //{ text: "Estado", value: "empleado_perfil_completo", align: "center" },
      { text: "# Empleado", value: "codigo_empleado", align: "center" },
      { text: "Nombre", value: "nombre", align: "center" },
      { text: "Apellido paterno", value: "apellido_paterno", align: "center" },
      { text: "Apellido materno", value: "apellido_materno", align: "center" },
      { text: "Puesto", value: "nombre_puesto", align: "center" },
      { text: "RFC", value: "rfc_valor", align: "center" },
      { text: "Expediente", value: "id_estado_empleado", align: "center" },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    headersContratos: [
      { text: "Estado del perfil", value: "perfil", align: "center" },
      { text: "Contrato", value: "nombre_contrato", align: "left" },
      { text: "Puesto", value: "nombre_puesto", align: "left" },
      { text: "Desde", value: "desde_puesto", align: "center" },
      { text: "Hasta", value: "hasta_puesto", align: "center" },
      { text: "Documento", value: "contrato_documento", align: "center" },
      { text: "Adendas", value: "adendas", align: "center", sortable: false },
      { text: "Acciones", value: "acciones", align: "center", sortable: false }
    ],
    headersAdendasContrato: [
      { text: "Adenda", value: "nombre_adenda", align: "left" },
      { text: "Motivo", value: "nombre_motivo", align: "left" },
      { text: "Estado", value: "estado", align: "center" },
      { text: "Cargada por", value: "cargada_por", align: "center" },
      { text: "Fecha de carga", value: "fecha_cargo_adenda", align: "center" },
      { text: "Acciones", value: "acciones", align: "center", sortable: false }
    ],
    curpRules: [v => (v && v.length === 18) || 'La longitud de la CURP debe de ser de 18 caracteres'],
    rfcRules: [v => (v && v.length === 13) || 'La longitud del RFC debe de ser de 13 caracteres'],
    siNoOptions: [
      { text: 'Sí', value: true },
      { text: 'No', value: false },
    ],
    editedItem: {
      id_empleado: null,
      nombre_puesto: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: null,
      //id_estado_civil: null,
      //nombre_estado_civil: null,
      //id_estado_civil_legal: null,
      //nombre_estado_civil_legal: null,
      curp_valor: null,
      rfc_valor: null,
      //nss_valor: null,
      noi_numero_trabajador: null,
      telefono: null,
      email: null,
      id_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      //regimen_sueldos: null,
      //tiene_credito: null,
      //ids_tipo_credito: [],
      //id_usuario: null,
      aceptar_curp_invalido: false,
      aceptar_rfc_invalido: false,
    },
    defaultEditedItem: {
      id_empleado: null,
      nombre_puesto: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: null,
      //id_estado_civil: null,
      //nombre_estado_civil: null,
      //id_estado_civil_legal: null,
      //nombre_estado_civil_legal: null,
      curp_valor: null,
      rfc_valor: null,
      //nss_valor: null,
      noi_numero_trabajador: null,
      telefono: null,
      email: null,
      id_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      //regimen_sueldos: null,
      //tiene_credito: null,
      //ids_tipo_credito: [],
      //id_usuario: null,
      aceptar_curp_invalido: false,
      aceptar_rfc_invalido: false,
    },
    viewedItem: {
      id_empleado: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      //id_estado_civil_legal: null,
      //nombre_estado_civil_legal: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      nombre_estado: null,
      id_municipio: null,
      nombre_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      cuentas_bancarias: [],
      requisitos: []
    },
    defaultViewedItem: {
      id_empleado: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      //id_estado_civil_legal: null,
      //nombre_estado_civil_legal: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      nombre_estado: null,
      id_municipio: null,
      nombre_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      cuentas_bancarias: [],
      requisitos: []
    },
    loadingSave: false,
    urlBase: "/api/RecursosHumanos/DescargarDocumento",
    //estados_civiles: [],
    //loadingEstadosCiviles: false,
    loadingUser: false,

    puestos: [],
    loadingPuestos: false,

    generos: [
      { text: "Femenino", value: 0 },
      { text: "Masculino", value: 1 },
    ],

    //creditoTipos: [],
    //loadingCreditoTipos: false,
    stats: {
      cumpliento_per: 0,
      cumpliento_num: 0,
      pendiente_per: 0,
      pendiente_num: 0,
      validacion_per: 0,
      validacion_num: 0,
      validado_per: 0,
      validado_num: 0,
      total: 0,
    },
    defaultStats: {
      cumpliento_per: 0,
      cumpliento_num: 0,
      pendiente_per: 0,
      pendiente_num: 0,
      validacion_per: 0,
      validacion_num: 0,
      validado_per: 0,
      validado_num: 0,
      total: 0,
    },
    loadingDetails: false,
    areaPuestos: [],
    loadingAreaPuestos: false,

    search: {
      codigoEmpleado: '',
      nombre: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      rfc: '',
      tipoPuestos:[],
      puestos: []
    },
    curpRegex: /^[A-Z0-9]{18}$/,
    rfcRegex: /^[A-Z0-9]{13}$/,
    errorMode: 0,
  }),
  mounted() {
    this.getItems();
    this.getPuestos();
    this.getRHAreas();
    //this.getEstadosCiviles();
    //this.getCreditoTipos();

  },
  methods: {
    estadoExpedienteNombre(estado) {
      if (estado === 1) return 'Pendiente de carga';
      if (estado === 2) return 'En espera de validación';
      if (estado === 3) return 'Validado';
      return 'Sin expediente';
    },
    estadoExpedienteIcon(estado) {
      if (estado === 1) return 'mdi-timer-sand';
      if (estado === 2) return 'mdi-file-find-outline';
      if (estado === 3) return 'mdi-check';
      return 'mdi-file-question-outline';
    },
    estadoExpedienteColor(estado) {
      if (estado === 1) return 'blue';
      if (estado === 2) return 'orange';
      if (estado === 3) return 'green';
      return 'deep-purple';
    },
    estadoExpedienteTextColor(estado) {
      return estado === 1 ? 'white' : 'white';
    },
    resumenExpediente(item, tipo) {
      const pendientes = tipo === 'próximo'
        ? item.expediente_puesto_futuro_pendientes
        : item.expediente_pendientes;
      return pendientes?.resumen || '';
    },
    estadoExpedienteTooltip(item, tipo) {
      const esProximo = tipo === 'próximo';
      const estado = esProximo
        ? item.id_estado_expediente_puesto_futuro
        : item.id_estado_empleado;
      const prefijo = esProximo
        ? `Expediente del próximo puesto${item.nombre_puesto_futuro ? ` (${item.nombre_puesto_futuro})` : ''}`
        : 'Expediente actual';
      const inicio = esProximo && item.fecha_desde_puesto_futuro
        ? ` Inicia el ${item.fecha_desde_puesto_futuro}.`
        : '';

      const pendientes = esProximo
        ? item.expediente_puesto_futuro_pendientes
        : item.expediente_pendientes;
      const resumen = pendientes?.detalle || this.resumenExpediente(item, tipo);
      if (estado !== 3 && resumen) return `${prefijo}: ${resumen}${resumen.endsWith('.') ? '' : '.'}${inicio}`;
      if (estado === 1) return `${prefijo}: Pendiente de carga.${inicio}`;
      if (estado === 2) return `${prefijo}: En espera de validación.${inicio}`;
      if (estado === 3) {
        const validadoPor = esProximo
          ? item.expediente_puesto_futuro_validado_por
          : item.expediente_validado_por;
        const validadoFecha = esProximo
          ? item.expediente_puesto_futuro_validado_fecha
          : item.expediente_validado_fecha;
        return `${prefijo}: Documentación Validada${validadoPor ? ` por ${validadoPor}` : ''}${validadoFecha ? ` desde ${validadoFecha}` : ''}.${inicio}`;
      }
      return `${prefijo}: Sin expediente.${inicio}`;
    },
    uuidv4(){ return v4(); },
    getPuestos(){
      this.loadingPuestos = true;
      axios.get('/RecursosHumanos/ListarPuestos')
        .then(r => { this.puestos = r.data; })
        .catch(() => { /* noop */ })
        .finally(() => { this.loadingPuestos = false; })
    },
    getRHAreas() {
      this.loadingAreaPuestos = true;
      axios
        .get("/RHCatalogos/ListarRHAreas")
        .then((res) => {
          this.areaPuestos = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingAreaPuestos = false;
        });
    },
    getUrl(){
      const url = new URL(`http://localhost/RecursosHumanos/ListarEmpleados`);
      if(this.search.codigoEmpleado != null && this.search.codigoEmpleado.length > 0) url.searchParams.append("codigo_empleado", this.search.codigoEmpleado);
      if(this.search.nombre != null && this.search.nombre.length > 0) url.searchParams.append("nombre", this.search.nombre);
      if(this.search.apellidoPaterno != null && this.search.apellidoPaterno.length > 0) url.searchParams.append("apellido_paterno", this.search.apellidoPaterno);
      if(this.search.apellidoMaterno != null && this.search.apellidoMaterno.length > 0) url.searchParams.append("apellido_materno", this.search.apellidoMaterno);
      if(this.search.rfc != null && this.search.rfc.length > 0) url.searchParams.append("rfc", this.search.rfc);
      
      if(this.search.tipoPuestos != null && this.search.tipoPuestos.length > 0) {
        this.search.tipoPuestos.forEach(tp => {
          url.searchParams.append("ids_rh_areas", tp);
        })
      }
      
      if(this.search.puestos != null && this.search.puestos.length > 0) {
        this.search.puestos.forEach(p => {
          url.searchParams.append("ids_puestos", p);
        })
      }

      return url.href.replace('http://localhost', '');
    },
    openDialogContratos(item) {
      if (!item || !item.id_empleado) return;

      this.empleadoContratos = {
        id_empleado: item.id_empleado,
        nombre: item.nombre || '',
        apellido_paterno: item.apellido_paterno || '',
        apellido_materno: item.apellido_materno || '',
        codigo_empleado: item.codigo_empleado || ''
      };
      this.contratos = [];
      this.dialogContratos = true;
      this.loadingContratos = true;

      axios.get('/RecursosHumanos/ListarEmpleadoContratos/' + item.id_empleado)
        .then(response => {
          this.contratos = response.data || [];
        })
        .catch(error => {
          this.contratos = [];
          if (error.response && error.response.status === 404) {
            this.$showAlert('', 'No se encontró el empleado.');
          } else {
            this.$showAlert('', 'No se pudieron obtener los contratos del empleado.');
          }
        })
        .finally(() => {
          this.loadingContratos = false;
        });
    },
    closeDialogContratos() {
      this.dialogContratos = false;
      this.cerrarAdendasContrato();
      this.cerrarCargaAdenda();
      this.loadingContratos = false;
      this.contratos = [];
      this.dialogAsignarTipoContrato = false;
      this.contratoParaAsignarTipo = null;
      this.dialogCargarContrato = false;
      this.contratoParaCarga = null;
      this.cerrarDescargaContrato();
      this.cerrarDescargaAdenda();
      this.empleadoContratos = {
        id_empleado: null,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        codigo_empleado: ''
      };
    },
    abrirAsignarTipoContrato(contrato) {
      if (!contrato || !contrato.id_empleado_puesto) return;
      this.contratoParaAsignarTipo = Object.assign({}, contrato, {
        codigo_empleado: this.empleadoContratos.codigo_empleado,
        nombre: this.empleadoContratos.nombre,
        apellido_paterno: this.empleadoContratos.apellido_paterno,
        apellido_materno: this.empleadoContratos.apellido_materno
      });
      this.dialogAsignarTipoContrato = true;
    },
    tipoContratoAsignado() {
      if (this.empleadoContratos && this.empleadoContratos.id_empleado) {
        this.openDialogContratos(this.empleadoContratos);
      }
    },
    abrirCargaContrato(contrato) {
      if (!contrato || !contrato.id_empleado_puesto) return;
      this.contratoParaCarga = Object.assign({}, contrato, {
        codigo_empleado: this.empleadoContratos.codigo_empleado,
        nombre: this.empleadoContratos.nombre,
        apellido_paterno: this.empleadoContratos.apellido_paterno,
        apellido_materno: this.empleadoContratos.apellido_materno
      });
      this.dialogCargarContrato = true;
    },
    contratoCargado() {
      if (this.empleadoContratos && this.empleadoContratos.id_empleado) {
        this.openDialogContratos(this.empleadoContratos);
      }
    },
    abrirDescargaContrato(contrato) {
      if (!contrato || !contrato.id_empleado_puesto) return;
      this.contratoParaDescarga = contrato;
      this.ciudadDescargaContrato = null;
      this.dialogDescargarContrato = true;
    },
    cerrarDescargaContrato() {
      this.dialogDescargarContrato = false;
      this.contratoParaDescarga = null;
      this.ciudadDescargaContrato = null;
    },
    async descargarContratoIndividual() {
      if (!this.contratoParaDescarga || !this.ciudadDescargaContrato) return;
      this.descargandoContrato = true;
      try {
        const response = await axios.post('/RecursosHumanos/DescargarContratoIndividual', {
          id_empleado_puesto: this.contratoParaDescarga.id_empleado_puesto,
          ciudad: this.ciudadDescargaContrato
        }, { responseType: 'blob' });
        const url = URL.createObjectURL(response.data);
        this.nuevaPestana(url);
        setTimeout(() => URL.revokeObjectURL(url), 60000);
        this.cerrarDescargaContrato();
      } catch (error) {
        this.$refs.alert.setMessage('', 'No se pudo generar el contrato para su descarga.');
        this.$refs.alert.open();
      } finally {
        this.descargandoContrato = false;
      }
    },
    abrirDescargaAdenda(adenda) {
      if (!adenda || !adenda.id_empleado_puesto_adenda || adenda.documento) return;
      this.adendaParaDescarga = adenda;
      this.ciudadDescargaAdenda = null;
      this.dialogDescargarAdenda = true;
    },
    cerrarDescargaAdenda() {
      this.dialogDescargarAdenda = false;
      this.adendaParaDescarga = null;
      this.ciudadDescargaAdenda = null;
    },
    async descargarAdendaIndividual() {
      if (!this.adendaParaDescarga || !this.ciudadDescargaAdenda) return;
      this.descargandoAdenda = true;
      try {
        const response = await axios.post('/RecursosHumanos/DescargarAdendaIndividual', {
          id_empleado_puesto_adenda: this.adendaParaDescarga.id_empleado_puesto_adenda,
          ciudad: this.ciudadDescargaAdenda
        }, { responseType: 'blob' });
        const url = URL.createObjectURL(response.data);
        this.nuevaPestana(url);
        setTimeout(() => URL.revokeObjectURL(url), 60000);
        this.cerrarDescargaAdenda();
      } catch (error) {
        this.$refs.alert.setMessage('', 'No se pudo generar la adenda para su descarga.');
        this.$refs.alert.open();
      } finally {
        this.descargandoAdenda = false;
      }
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    descargarAdenda(adenda) {
      if (!adenda || !adenda.documento) return;
      window.open('/api/RecursosHumanos/DescargarEmpleadoPuestoAdenda/' + adenda.documento + '?jwt=' + this.token, '_blank');
    },
    adendasPendientes(contrato) {
      return (contrato.adendas || []).filter(adenda => !adenda.documento);
    },
    adendasCargadas(contrato) {
      return (contrato.adendas || []).filter(adenda => !!adenda.documento);
    },
    abrirAdendasContrato(contrato) {
      this.contratoAdendas = Object.assign({}, contrato, {
        adendas: [...(contrato.adendas || [])]
      });
      this.dialogAdendasContrato = true;
    },
    cerrarAdendasContrato() {
      this.dialogAdendasContrato = false;
      this.contratoAdendas = {};
    },
    async abrirCrearAdenda(contrato) {
      if (!contrato || !contrato.id_empleado_puesto) return;
      this.contratoParaAdenda = Object.assign({}, contrato);
      this.idTipoAdenda = null;
      this.idMotivoAdenda = null;
      this.dialogCrearAdenda = true;

      if (this.tiposAdenda.length > 0 && this.motivosAdenda.length > 0) return;
      this.loadingTiposAdenda = true;
      try {
        const [tipos, motivos] = await Promise.all([
          axios.get('/RecursosHumanos/ListarEmpleadoAdendaTipos'),
          axios.get('/RecursosHumanos/ListarEmpleadoAdendaMotivos')
        ]);
        this.tiposAdenda = tipos.data || [];
        this.motivosAdenda = motivos.data || [];
      } catch (error) {
        this.$refs.alert.setMessage('', 'No se pudieron obtener los catálogos de adenda.');
        this.$refs.alert.open();
      } finally {
        this.loadingTiposAdenda = false;
      }
    },
    cerrarCrearAdenda() {
      this.dialogCrearAdenda = false;
      this.idTipoAdenda = null;
      this.idMotivoAdenda = null;
      this.contratoParaAdenda = {};
    },
    async crearAdenda() {
      if (!this.idTipoAdenda || !this.idMotivoAdenda || !this.contratoParaAdenda.id_empleado_puesto) return;
      const idEmpleadoPuesto = this.contratoParaAdenda.id_empleado_puesto;
      this.savingAdenda = true;
      try {
        await axios.post('/RecursosHumanos/CrearEmpleadoPuestoAdenda', {
          id_empleado_puesto: this.contratoParaAdenda.id_empleado_puesto,
          id_empleado_adenda_tipo: this.idTipoAdenda,
          id_empleado_adenda_motivo: this.idMotivoAdenda
        });
        this.cerrarCrearAdenda();
        this.$nextTick(() => {
          this.dialogAdendasContrato = true;
        });
        if (this.empleadoContratos && this.empleadoContratos.id_empleado) {
          try {
            const response = await axios.get('/RecursosHumanos/ListarEmpleadoContratos/' + this.empleadoContratos.id_empleado);
            this.contratos = response.data || [];
            const contratoActualizado = this.contratos.find(contrato => contrato.id_empleado_puesto === idEmpleadoPuesto);
            if (contratoActualizado) {
              this.contratoAdendas = Object.assign({}, contratoActualizado, {
                adendas: [...(contratoActualizado.adendas || [])]
              });
            }
          } catch (error) {
            this.$refs.alert.setMessage('', 'La adenda se creó, pero no se pudo actualizar su información.');
            this.$refs.alert.open();
          }
        }
      } catch (error) {
        const data = error && error.response && error.response.data;
        this.$refs.alert.setMessage('', (data && (data.msg || data.message)) || 'No se pudo crear la adenda.');
        this.$refs.alert.open();
      } finally {
        this.savingAdenda = false;
      }
    },
    abrirCargaAdenda(item, adenda) {
      this.contratoAdendas = Object.assign({}, item, {
        adendas: [...(item.adendas || [])]
      });
      this.adendaParaCarga = Object.assign({}, adenda);
      this.archivoAdenda = null;
      this.dialogCargaAdenda = true;
    },
    cerrarCargaAdenda() {
      this.dialogCargaAdenda = false;
      this.adendaParaCarga = {};
      this.archivoAdenda = null;
    },
    async cargarAdenda() {
      if (!this.archivoAdenda) {
        this.$refs.alert.setMessage('', 'Debe seleccionar el documento firmado en formato PDF.');
        this.$refs.alert.open();
        return;
      }
      if (!/\.pdf$/i.test(this.archivoAdenda.name || '')) {
        this.$refs.alert.setMessage('', 'Solo se aceptan archivos PDF.');
        this.$refs.alert.open();
        return;
      }

      const formData = new FormData();
      formData.append('id_empleado_puesto_adenda', this.adendaParaCarga.id_empleado_puesto_adenda);
      formData.append('documento', this.archivoAdenda);
      this.savingCargaAdenda = true;
      try {
        await axios.post('/RecursosHumanos/CargarEmpleadoPuestoAdenda', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        this.cerrarCargaAdenda();
        if (this.empleadoContratos && this.empleadoContratos.id_empleado) {
          const idEmpleadoPuesto = this.contratoAdendas.id_empleado_puesto;
          const response = await axios.get('/RecursosHumanos/ListarEmpleadoContratos/' + this.empleadoContratos.id_empleado);
          this.contratos = response.data || [];
          const contratoActualizado = this.contratos.find(contrato => contrato.id_empleado_puesto === idEmpleadoPuesto);
          if (contratoActualizado) {
            this.contratoAdendas = Object.assign({}, contratoActualizado, {
              adendas: [...(contratoActualizado.adendas || [])]
            });
          }
          this.$nextTick(() => {
            this.dialogAdendasContrato = true;
          });
        }
      } catch (error) {
        const data = error && error.response && error.response.data;
        this.$refs.alert.setMessage('', (data && (data.msg || data.message)) || 'No se pudo cargar la adenda.');
        this.$refs.alert.open();
      } finally {
        this.savingCargaAdenda = false;
      }
    },
    cancelarAdenda(adenda) {
      if (!adenda || adenda.documento) return;
      this.adendaParaCancelar = adenda;
      this.$refs.confirmCancelarAdenda.setMessage('', '¿Deseas cancelar la adenda "' + adenda.nombre_adenda + '"?');
      this.$refs.confirmCancelarAdenda.open();
    },
    confirmarCancelacionAdenda() {
      const adenda = this.adendaParaCancelar;
      this.adendaParaCancelar = null;
      if (!adenda) return;

      axios.post('/RecursosHumanos/CancelarEmpleadoPuestoAdenda/' + adenda.id_empleado_puesto_adenda)
        .then(() => {
          const contrato = this.contratos.find(x => (x.adendas || []).some(a => a.id_empleado_puesto_adenda === adenda.id_empleado_puesto_adenda));
          if (contrato) contrato.adendas = (contrato.adendas || []).filter(a => a.id_empleado_puesto_adenda !== adenda.id_empleado_puesto_adenda);
          this.contratoAdendas.adendas = (this.contratoAdendas.adendas || []).filter(a => a.id_empleado_puesto_adenda !== adenda.id_empleado_puesto_adenda);
        })
        .catch(error => {
          const data = error && error.response && error.response.data;
          this.$refs.alert.setMessage('', (data && (data.msg || data.message)) || 'No se pudo cancelar la adenda.');
          this.$refs.alert.open();
        });
    },
    getItems() {
      this.loading = true;
      this.stats = Object.assign({}, this.defaultStats);
      this.items = [];
      
      axios.get(this.getUrl())
      .then(r => { 
        this.items = r.data;

        this.stats.total = r.data.filter(x => x.id_estado_empleado >= 1 && x.id_estado_empleado <= 3).length
        
        this.stats.cumpliento_num = r.data.filter(x => x.empleado_perfil_completo == true).length;
        this.stats.cumpliento_per = this.stats.total > 0 ? (this.stats.cumpliento_num / this.stats.total) : 0;

        this.stats.pendiente_num = r.data.filter(x => x.id_estado_empleado === 1).length;
        this.stats.pendiente_per = this.stats.total > 0 ? (this.stats.pendiente_num / this.stats.total) : 0;
        
        this.stats.validacion_num =  r.data.filter(x => x.id_estado_empleado === 2).length;
        this.stats.validacion_per = this.stats.total > 0 ? (this.stats.validacion_num / this.stats.total) : 0;
        
        this.stats.validado_num = r.data.filter(x => x.id_estado_empleado === 3).length,
        this.stats.validado_per = this.stats.total > 0 ? (this.stats.validado_num / this.stats.total) : 0;
        
      })
      .catch(() => {
       })
      .finally(() => {
        this.loading = false;
      })
    },
    openDialogAddEdit(editItem = null) {
      if(editItem != null) this.editedItem = Object.assign({}, this.defaultEditedItem, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = true;
    },
    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },
    validEmployee(){
      if(!this.editedItem.nombre){ this.$refs.alert.setMessage('', 'Debe de proporcionar un Nombre'); this.$refs.alert.open(); return false; }
      if(!this.editedItem.apellido_paterno){ this.$refs.alert.setMessage('', 'Debe de proporcionar un Apellido paterno'); this.$refs.alert.open(); return false; }
      if(!this.editedItem.apellido_materno){ this.$refs.alert.setMessage('', 'Debe de proporcionar un Apellido paterno'); this.$refs.alert.open(); return false; }
      if(!this.editedItem.fecha_nacimiento){ this.$refs.alert.setMessage('', 'Debe de indicar una Fecha de nacimiento'); this.$refs.alert.open(); return false; }
      if(this.editedItem.genero == null){ this.$refs.alert.setMessage('', 'Debe de seleccionar un Genero'); this.$refs.alert.open(); return false; }

      const curp = this.editedItem.curp_valor?.trim().toUpperCase();
      const rfc  = this.editedItem.rfc_valor?.trim().toUpperCase();

      if (!curp || !this.curpRegex.test(curp)) {
        this.$refs.alert.setMessage(
          '',
          'La CURP debe contener 18 caracteres alfanuméricos, sin espacios ni símbolos.'
        );
        this.$refs.alert.open();
        return false;
      }

      if (!rfc || !this.rfcRegex.test(rfc)) {
        this.$refs.alert.setMessage(
          '',
          'El RFC debe contener 13 caracteres alfanuméricos, sin espacios ni símbolos.'
        );
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.telefono){ this.$refs.alert.setMessage('', 'Debe de proporcionar un Teléfono de contacto'); this.$refs.alert.open(); return false; }
      if(!this.editedItem.email){ this.$refs.alert.setMessage('', 'Debe de proporcionar un Email de contacto'); this.$refs.alert.open(); return false; }
      if(this.editedItem.id_puesto == null){ this.$refs.alert.setMessage('', 'Debe de seleccionar un Puesto'); this.$refs.alert.open(); return false; }
      return true;
    },
    saveDialogAddEdit() {
      if (!this.validEmployee()) return;
      this.loadingSave = true;

      axios({
        method: this.editedItem.id_empleado == null ? 'POST' : 'PUT',
        url: this.editedItem.id_empleado == null ? '/RecursosHumanos/CrearEmpleado' : `/RecursosHumanos/EditarEmpleado/${this.editedItem.id_empleado}`,
        data: this.editedItem,
      })
      .then(() => { this.getItems(); this.closeDialogAddEdit(); })
      .catch(error => {
        if (error.response && error.response.status == 409) {
          this.$refs.alert.setMessage('', error.response.data.msg.replace('Error : ', ''));
          this.$refs.alert.open();
          return;
        }
        else if(error.response && error.response.status == 535){
          this.errorMode = 535;

          this.$refs.confirm.setMessage(
            '',
            'El CURP capturado no es válido. ¿Deseas aceptarlo y continuar bajo su responsabilidad?'
          );
          this.$refs.confirm.open();
        }
        else if(error.response && error.response.status == 536){
          this.errorMode = 536;
          this.$refs.confirm.setMessage(
            '',
            'El RFC capturado no es válido. ¿Deseas aceptarlo y continuar bajo su responsabilidad?'
          );
          this.$refs.confirm.open();
        }
        else console.log(error);
      })
      .finally(() => { this.loadingSave = false; });
    },
    botonAceptar() {
      if (this.errorMode === 535) return 'Aceptar CURP y continuar';
      if (this.errorMode === 536) return 'Aceptar RFC y continuar';
      return '';
    },

    botonCancelar() {
      if (this.errorMode === 535) return 'Corregir CURP';
      if (this.errorMode === 536) return 'Corregir RFC';
      return '';
    },
    autorizarExcepcion(){
      if(this.errorMode == 535){
        this.editedItem.aceptar_curp_invalido = true;
      }
      else if(this.errorMode == 536){
        this.editedItem.aceptar_rfc_invalido = true;
      }
      this.errorMode = 0;
    },
    cancelarExcepcion(){
      this.errorMode = 0;
    },
    buscarUsuario(){
      if(this.editedItem.rfc_valor == null || this.editedItem.rfc_valor.length != 13) return;
      this.loadingUser = true;
      axios.get(`/Users/GetUserUnlinked/${this.editedItem.rfc_valor}`)
      .then(response => {
        if(response.data.id_usuario != null) {
          this.editedItem.id_usuario = response.data.id_usuario;
          this.editedItem.nombre_usuario = response.data.nombre_completo;
          this.editedItem.crear_usuario = false;
        } else {
          this.editedItem.id_usuario = null;
          this.editedItem.nombre_usuario = null;
          this.editedItem.crear_usuario = true;
        }
      })
      .catch(() => {
        this.editedItem.id_usuario = null;
        this.editedItem.nombre_usuario = null;
        this.editedItem.crear_usuario = true;
      })
      .finally(() => { this.loadingUser = false })
    },
    openDialogView(editItem) {
      this.puestosVista = {
        actual: editItem.id_empleado_puesto || null,
        futuro: editItem.id_empleado_puesto_futuro || null
      };
      this.tabView = this.tienePuestoActual ? 'actual' : 'futuro';

      if (!this.tabView) {
        this.$refs.alert.setMessage('', 'El empleado no tiene un puesto actual ni futuro para consultar.');
        this.$refs.alert.open();
        return;
      }

      this.dialogView = true;
      this.loadDetallePuesto(this.tabView);
    },
    cambiarPuestoVista(tab) {
      if (!tab) return;
      this.tabView = tab;
      this.loadDetallePuesto(tab);
    },
    loadDetallePuesto(tipoPuesto) {
      const idEmpleadoPuesto = this.puestosVista[tipoPuesto];
      if (!idEmpleadoPuesto) return;

      this.loadingDetails = true;
      axios
      .get(`/RecursosHumanos/DetalleEmpleadoPuesto/${idEmpleadoPuesto}`)
      .then(response => {
        this.viewedItem = response.data;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loadingDetails = false;
      })
    },
    closeDialogView() {
      this.viewedItem = Object.assign({}, this.defaultViewedItem);
      this.tabView = null;
      this.puestosVista = {
        actual: null,
        futuro: null
      };
      this.dialogView = false;
    },
    async openDialogRecargaExpediente(item) {
      if (!item || !item.id_empleado) return;

      this.empleadoRecarga = Object.assign({}, item);
      this.puestosExpediente = [];
      this.puestoRecargaSeleccionado = null;
      this.dialogRecargaExpediente = true;
      this.loadingPuestosExpediente = true;

      try {
        const response = await axios.get(`/RecursosHumanos/ListarPuestosExpediente/${item.id_empleado}`);
        const data = response.data;
        this.puestosExpediente = Array.isArray(data)
          ? data
          : (data && (data.data || data.items)) || [];
      } catch (error) {
        const data = error && error.response && error.response.data;
        const message = (data && (data.msg || data.message || data.title)) || 'No fue posible cargar los puestos del empleado.';
        this.$refs.alert.setMessage('', message);
        this.$refs.alert.open();
        this.closeDialogRecargaExpediente();
      } finally {
        this.loadingPuestosExpediente = false;
      }
    },
    closeDialogRecargaExpediente() {
      this.dialogRecargaExpediente = false;
      this.loadingPuestosExpediente = false;
      this.savingRecargaExpediente = false;
      this.empleadoRecarga = null;
      this.puestosExpediente = [];
      this.puestoRecargaSeleccionado = null;
    },
    seleccionarPuestoRecarga(idEmpleadoPuesto, seleccionado) {
      this.puestoRecargaSeleccionado = seleccionado ? idEmpleadoPuesto : null;
    },
    async solicitarRecargaExpediente() {
      if (!this.puestoRecargaSeleccionado) {
        this.$refs.alert.setMessage('', 'Debe seleccionar el puesto para solicitar la nueva carga de documentación.');
        this.$refs.alert.open();
        return;
      }

      this.savingRecargaExpediente = true;
      try {
        await axios.post(`/RecursosHumanos/SolicitarRecargaExpediente/${this.puestoRecargaSeleccionado}`);
        this.closeDialogRecargaExpediente();
        this.getItems();
      } catch (error) {
        const data = error && error.response && error.response.data;
        const message = (data && (data.msg || data.message || data.title)) || 'No fue posible solicitar la nueva carga de documentación.';
        this.$refs.alert.setMessage('', message);
        this.$refs.alert.open();
      } finally {
        this.savingRecargaExpediente = false;
      }
    },
    construirPeriodoExpediente(puesto) {
      return `${puesto.fecha_desde || 'N/D'} - ${puesto.fecha_hasta || 'Indefinido'}`;
    },
    disableBrowserAutocomplete (event) {
      if (!event || !event.target) return

      // Le cambiamos el name a algo único y raro
      const randomName = 'field_' + Math.random().toString(36).substring(2)
      event.target.setAttribute('name', randomName)

      // Forzamos autocomplete off
      event.target.setAttribute('autocomplete', 'off')
    },
    formatMoney(number) {
      if(!number) return "";
      // Convierte el número a un string con dos decimales
      let numberString = number.toFixed(2);

      // Usa una expresión regular para agregar comas cada tres dígitos
      let formattedNumber = "$"+numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return formattedNumber;
    },
    openDialogPuestos(item){
      if (this.$refs.empleadoPuestos && this.$refs.empleadoPuestos.open) {
        this.$refs.empleadoPuestos.open(item.id_empleado);
      }
    },
    openDialogCargaMasiva(){
      if (this.$refs.cargaMasiva && this.$refs.cargaMasiva.open) {
        this.$refs.cargaMasiva.open();
      }
    },
    pct (v) {
      return `${(v * 100).toFixed(1)}%`
    },
    nf (n) {
      return new Intl.NumberFormat('es-MX').format(n || 0)
    },
    changeTipoPuestos(){
      this.puestosSearch = [];
    }
  },
  computed: {
    ...mapState(['token']),
    tienePuestoActual() {
      return this.puestosVista.actual != null;
    },
    tienePuestoFuturo() {
      return this.puestosVista.futuro != null;
    },
    cuentasBancariasVista() {
      return Array.isArray(this.viewedItem.cuentas_bancarias) ? this.viewedItem.cuentas_bancarias : [];
    },
    puestosFiltrados(){
      if(!this.search.tipoPuestos || this.search.tipoPuestos.length <= 0) return this.puestos;

      return this.puestos.filter(p => this.search.tipoPuestos.includes(p.id_rh_area));
    }
  }
};
</script>


<style scoped>
.autocomplete-trap {
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 0;
  height: 0;
  overflow: hidden;
}

.kpi-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.kpi-figure {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  border: 1px solid transparent;
}

/* Variantes de color (ajústalas a tu paleta Vuetify si quieres) */
.kpi-pill--success {
  background: #e8f5e9;   /* green lighten-5 */
  color: #2e7d32;        /* green darken-3 */
  border-color: #c8e6c9; /* green lighten-4 */
}

.kpi-pill--info {
  background: #e3f2fd;   /* blue lighten-5 */
  color: #1565c0;        /* blue darken-3 */
  border-color: #bbdefb; /* blue lighten-4 */
}

.kpi-pill--warning {
  background: #fff8e1;   /* amber lighten-5 */
  color: #ef6c00;        /* orange darken-3 */
  border-color: #ffe0b2; /* orange lighten-4 */
}

.expediente-motivo {
  max-width: 300px;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}

.expediente-estados {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}

::v-deep .viewer-contrato-compacto .custom-btn {
  width: auto;
  padding: 6px 10px;
  font-size: 0.8rem;
}

::v-deep .viewer-adenda-compacto .custom-btn {
  width: auto;
  padding: 4px 8px;
  font-size: 0.75rem;
}
</style>

<style>
.expediente-tooltip {
  max-width: 300px !important;
  white-space: normal;
  background: #000 !important;
  color: #fff !important;
}

.acciones-tooltip {
  background: #000 !important;
  color: #fff !important;
}
</style>
